(function ($) {
    $.fn.checkboxGroup = function (grouperSelector, groupSelector) {
        return this.each(function () {
            var scope = $(this),
                grouper = scope.find(grouperSelector);

            grouper.change(function () {
                var checked = grouper.is(':checked');
                scope.find(groupSelector).prop('checked', checked).trigger('change');
                scope.trigger('grouperCheck', checked);
            });

            scope.on('change', groupSelector, function () {
                var checked = true, count = 0;
                scope.find(groupSelector).each(function () {
                    checked = checked && $(this).is(':checked');
                    if ($(this).is(':checked')) { count++; }
                });
                grouper.prop('checked', checked);
                scope.trigger('groupCheck', count);
            });
        });
    };
})(jQuery);
